/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  FilterSubLimitSettingsQueryDto,
  SubLimitSettingResponseDto,
  UpdateSubLimitSettingsPayloadDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FilterSubLimitSettingsQueryDtoFromJSON,
    FilterSubLimitSettingsQueryDtoToJSON,
    SubLimitSettingResponseDtoFromJSON,
    SubLimitSettingResponseDtoToJSON,
    UpdateSubLimitSettingsPayloadDtoFromJSON,
    UpdateSubLimitSettingsPayloadDtoToJSON,
} from '../models/index';

export interface FilterSubLimitSettingsRequest {
    filterSubLimitSettingsQueryDto: FilterSubLimitSettingsQueryDto;
}

export interface UpdateSubLimitSettingsRequest {
    updateSubLimitSettingsPayloadDto: Array<UpdateSubLimitSettingsPayloadDto>;
}

/**
 * 
 */
export class SubLimitSettingsApi extends runtime.BaseAPI {

    /**
     * Filter sub-limit settings
     */
    async filterSubLimitSettingsRaw(requestParameters: FilterSubLimitSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SubLimitSettingResponseDto>>> {
        if (requestParameters['filterSubLimitSettingsQueryDto'] == null) {
            throw new runtime.RequiredError(
                'filterSubLimitSettingsQueryDto',
                'Required parameter "filterSubLimitSettingsQueryDto" was null or undefined when calling filterSubLimitSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sub-limit-settings/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FilterSubLimitSettingsQueryDtoToJSON(requestParameters['filterSubLimitSettingsQueryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubLimitSettingResponseDtoFromJSON));
    }

    /**
     * Filter sub-limit settings
     */
    async filterSubLimitSettings(requestParameters: FilterSubLimitSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SubLimitSettingResponseDto>> {
        const response = await this.filterSubLimitSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update sub-limit settings
     */
    async updateSubLimitSettingsRaw(requestParameters: UpdateSubLimitSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SubLimitSettingResponseDto>>> {
        if (requestParameters['updateSubLimitSettingsPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'updateSubLimitSettingsPayloadDto',
                'Required parameter "updateSubLimitSettingsPayloadDto" was null or undefined when calling updateSubLimitSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sub-limit-settings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateSubLimitSettingsPayloadDto']!.map(UpdateSubLimitSettingsPayloadDtoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubLimitSettingResponseDtoFromJSON));
    }

    /**
     * Update sub-limit settings
     */
    async updateSubLimitSettings(requestParameters: UpdateSubLimitSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SubLimitSettingResponseDto>> {
        const response = await this.updateSubLimitSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
